module.exports = __webpack_public_path__ + "img/box.e5227aed.png";